import { render, staticRenderFns } from "./ChecklistVersion.vue?vue&type=template&id=581cbb53&scoped=true&"
import script from "./ChecklistVersion.vue?vue&type=script&lang=js&"
export * from "./ChecklistVersion.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistVersion.vue?vue&type=style&index=0&id=581cbb53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581cbb53",
  null
  
)

export default component.exports